import { render, staticRenderFns } from "./DonutChart19.vue?vue&type=template&id=b01d195c&scoped=true&"
import script from "./DonutChart19.vue?vue&type=script&lang=js&"
export * from "./DonutChart19.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01d195c",
  null
  
)

export default component.exports